import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './Auth.css';

const ROLES = [
  { value: 'etudiant',      label: 'Étudiant(e)' },
  { value: 'alumni',        label: 'Alumni / Professionnel(le)' },
  { value: 'diaspora',      label: 'Diaspora algérienne' },
  { value: 'organisation',  label: 'Organisation / Entreprise' },
];

const WILAYAS = [
  'Adrar','Chlef','Laghouat','Oum El Bouaghi','Batna','Béjaïa','Biskra','Béchar',
  'Blida','Bouira','Tamanrasset','Tébessa','Tlemcen','Tiaret','Tizi Ouzou',
  'Alger','Djelfa','Jijel','Sétif','Saïda','Skikda','Sidi Bel Abbès','Annaba',
  'Guelma','Constantine','Médéa','Mostaganem','MSila','Mascara','Ouargla','Oran',
  'El Bayadh','Illizi','Bordj Bou Arréridj','Boumerdès','El Tarf','Tindouf',
  'Tissemsilt','El Oued','Khenchela','Souk Ahras','Tipaza','Mila','Aïn Defla',
  'Naâma','Aïn Témouchent','Ghardaïa','Relizane','Timimoun','Bordj Badji Mokhtar',
  'Ouled Djellal','Béni Abbès','In Salah','In Guezzam','Touggourt','Djanet',
  'El MGeniaGhirous','El Menia',
];

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({
    first_name: '', last_name: '', email: '',
    password: '', password_confirmation: '',
    role: 'etudiant', phone: '', wilaya: '',
  });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const set = (key, val) => setForm((f) => ({ ...f, [key]: val }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrors({});
    setLoading(true);
    try {
      await register(form);
      navigate('/profil');
    } catch (err) {
      if (err.response?.data?.errors) {
        setErrors(err.response.data.errors);
      } else {
        setErrors({ _global: err.response?.data?.message || 'Erreur d\'inscription.' });
      }
    } finally {
      setLoading(false);
    }
  };

  const fieldErr = (k) => errors[k] ? <span className="field-error">{errors[k][0]}</span> : null;

  return (
    <div className="auth-page">
      <div className="auth-box wide">
        <div className="auth-logo">
          <img src={`${process.env.PUBLIC_URL}/logo/ynd-primary-gold-navy.jpg`} alt="" />
          <span className="auth-logo-text">YesNeDni</span>
        </div>
        <h1>Créer un compte</h1>
        <p className="auth-sub">Rejoins l'écosystème YesNeDni gratuitement.</p>

        {errors._global && <div className="auth-error">{errors._global}</div>}

        <form onSubmit={handleSubmit} className="auth-form">
          <div className="form-row">
            <div>
              <label>Prénom *</label>
              <input required value={form.first_name} onChange={(e) => set('first_name', e.target.value)} placeholder="Prénom" />
              {fieldErr('first_name')}
            </div>
            <div>
              <label>Nom *</label>
              <input required value={form.last_name} onChange={(e) => set('last_name', e.target.value)} placeholder="Nom" />
              {fieldErr('last_name')}
            </div>
          </div>

          <label>Adresse e-mail *</label>
          <input type="email" required value={form.email} onChange={(e) => set('email', e.target.value)} placeholder="vous@email.com" />
          {fieldErr('email')}

          <label>Je suis... *</label>
          <select value={form.role} onChange={(e) => set('role', e.target.value)}>
            {ROLES.map((r) => <option key={r.value} value={r.value}>{r.label}</option>)}
          </select>
          {fieldErr('role')}

          <div className="form-row">
            <div>
              <label>Mot de passe *</label>
              <input type="password" required minLength={8} value={form.password} onChange={(e) => set('password', e.target.value)} placeholder="Min. 8 caractères" />
              {fieldErr('password')}
            </div>
            <div>
              <label>Confirmer *</label>
              <input type="password" required value={form.password_confirmation} onChange={(e) => set('password_confirmation', e.target.value)} placeholder="Répéter le mot de passe" />
            </div>
          </div>

          <div className="form-row">
            <div>
              <label>Téléphone</label>
              <input type="tel" value={form.phone} onChange={(e) => set('phone', e.target.value)} placeholder="+213 6XX XXX XXX" />
            </div>
            <div>
              <label>Wilaya</label>
              <select value={form.wilaya} onChange={(e) => set('wilaya', e.target.value)}>
                <option value="">Sélectionner...</option>
                {WILAYAS.map((w) => <option key={w} value={w}>{w}</option>)}
                <option value="etranger">À l'étranger</option>
              </select>
            </div>
          </div>

          <button type="submit" className="auth-btn" disabled={loading}>
            {loading ? 'Création du compte...' : 'Créer mon compte'}
          </button>
        </form>

        <p className="auth-footer">
          Déjà inscrit ? <Link to="/login">Se connecter</Link>
        </p>
      </div>
    </div>
  );
}
